<template>
  <div class="swiper-card card-breathe">
    <transition-group
      name="fade-slide-bottom"
      tag="div"
      v-if="reveal"
      class="reveal-group"
      appear
    >

      <span :key="'count'" class="count">{{ count }}s</span>
      
      <h3 :key="'title-wrapper'">{{ slide.content.title }}</h3>
      <p :key="'byline-wrapper'">{{ slide.content.byline }}</p>
    </transition-group>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        reveal: false,
        internal: null,
        count: 1,
        showCount: false,
      }
    },

    props: {
      slide: {
        type: Object,
      },
    },

    mounted () {
      this.$watch('$route.params.stack', (slug) => {
        if (slug === this.slide.slug) {
          this.$emit('swiperUpdate');
          setTimeout(() => {
            this.play();
          }, 500);
        }
      }, { immediate: true });
    },

    beforeDestroy() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    },

    methods: {
      play() {
        // Play animation reveals
        this.reveal = true;
        
        // Keep increasing the counter by 1 every second
        this.interval = setInterval(() => {
          this.count += 1;
        }, 1000);

        // After 3 seconds, enable next button
        setTimeout(() => {
          this.$emit('enableNextAction');
        }, 3000);
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-breathe {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 70vh;
    padding: 0 1rem;
    text-align: center;

    .count {
      display: inline-block;
      position: relative;
      font-family: 'Circular';
      font-weight: bold;
      font-size: 6rem;
      margin-bottom: 1rem;
      text-shadow: 6px 6px rgba($yellow-tone-3, 0.25);
      animation: bounce-count 1s infinite;
    }

    h3 {
      font-family: 'Circular';
      font-weight: bold;
      font-size: 1.75rem;
      margin: 2rem 0 0.5rem 0;
    }

    p {
      font-family: 'Circular';
      font-size: 1.1rem;
    }
  }

  .reveal-group > *:nth-child(2) {
    transition-delay: 0.10s;
  }
  .reveal-group > *:nth-child(3) {
    transition-delay: 0.25s;
  }
  .reveal-group > *:nth-child(4) {
    transition-delay: 0.40s;
  }

  @keyframes bounce-count {
    0%, 100% {
      transform: translateY(0);
    }
    30% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(5px);
    }
  }
</style>

<style lang="scss">
  .fade-slide-bottom-enter-active {
    transition: all 0.5s ease;
  }
  .fade-slide-bottom-enter {
    opacity: 0;
    transform: translateY(50px);
  }
  .fade-slide-bottom-enter-to {
    opacity: 1;
    transform: translateY(0);
  }

  .count-fade-slide-enter-active,
  .count-fade-slide-leave-active {
    transition: all 0.3s ease;
    position: absolute;
  }

  .count-fade-slide-enter {
    opacity: 0;
    transform: translateY(10px);
  }

  .count-fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }
</style>